(() => {
  'use strict';
  if (customElements.get('od-back-in-stock')) return;
  class OnlyDreamBackInStock extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.watchVariant(); return; }
      this.ready = true;
      // Keep product-card click handlers from navigating away from the form.
      this.addEventListener('click', event => event.stopPropagation());
      this.addEventListener('keydown', event => event.stopPropagation());
      this.addEventListener('submit', event => this.subscribe(event));
      this.addEventListener('change', () => {
        if (!this.busy) {
          const status = this.querySelector('[role=status]');
          if (status) status.textContent = '';
        }
      });
      this.watchVariant();
    }
    disconnectedCallback() {
      clearInterval(this.variantTimer);
      this.variantTimer = null;
    }
    watchVariant() {
      if (this.dataset.mode !== 'product' || this.variantTimer) return;
      this.unavailable = new Set((this.dataset.unavailable || '').split(','));
      this.syncVariant();
      // Aurora may update the hidden input value without firing a change event.
      this.variantTimer = setInterval(() => this.syncVariant(), 200);
    }
    syncVariant() {
      const scope = this.closest('product-info');
      if (!scope) return;
      const field = scope.querySelector('form[action*="/cart/add"] [name="id"], [data-product-form-variant]');
      const id = field ? String(field.value || '') :
        (new URL(window.location.href).searchParams.get('variant') || this.dataset.selected || '');
      const show = this.unavailable.has(id);
      this.hidden = !show;
      if (show) this.style.removeProperty('display');
      else this.style.setProperty('display', 'none', 'important');
      if (id === this.lastVariant || this.busy) return;
      this.lastVariant = id;
      const choice = this.querySelector('[name="variant"]');
      if (show && choice) choice.value = id;
      const status = this.querySelector('[role=status]');
      if (status) status.textContent = '';
    }
    async subscribe(event) {
      event.preventDefault();
      event.stopPropagation();
      const form = event.target;
      if (this.busy || !form.reportValidity()) return;
      if (this.dataset.mode === 'product') {
        this.syncVariant();
        if (this.hidden) return;
      }
      const values = new FormData(form);
      const variant = String(values.get('variant') || '');
      const status = form.querySelector('[role=status]');
      const selectedChoice = form.querySelector('select');
      const selectedLabel = selectedChoice ? selectedChoice.selectedOptions[0].textContent : '';
      if (!/^\d+$/.test(variant)) {
        status.textContent = 'Seleziona la variante per cui desideri ricevere l’avviso.';
        return;
      }
      const payload = {data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {data: {type: 'profile', attributes: {email: String(values.get('email')).trim()}}},
          channels: ['EMAIL']
        },
        relationships: {variant: {data: {type: 'catalog-variant', id: '$shopify:::$default:::' + variant}}}
      }};
      this.busy = true;
      const controls = [...form.querySelectorAll('input, select, button')];
      controls.forEach(control => control.disabled = true);
      form.setAttribute('aria-busy', 'true');
      status.textContent = 'Invio in corso…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.dataset.company), {
          method: 'POST',
          headers: {'Content-Type': 'application/json', revision: '2026-07-15'},
          body: JSON.stringify(payload), signal: controller.signal, credentials: 'omit'
        });
        if (response.status !== 202) {
          const failure = new Error('Request rejected');
          failure.status = response.status;
          throw failure;
        }
        const suffix = selectedLabel ? ' per ' + selectedLabel : '';
        status.textContent = 'Richiesta ricevuta' + suffix + '! Ti avviseremo via email quando torna disponibile.';
      } catch (error) {
        status.textContent = error.status === 429
          ? 'Troppe richieste. Attendi un minuto e riprova.'
          : 'Non è stato possibile confermare la richiesta. Controlla l’email e riprova tra poco.';
      } finally {
        clearTimeout(timeout);
        controls.forEach(control => control.disabled = false);
        form.removeAttribute('aria-busy');
        this.busy = false;
      }
    }
  }
  customElements.define('od-back-in-stock', OnlyDreamBackInStock);
})();
